import Vue from "vue";
import Router from "vue-router";
import paths from "./paths";
import { menuService } from "@/services/";
import { store } from "@/store";
import NProgress from 'nprogress';

Vue.use(Router);
NProgress.configure({ showSpinner: false });
export const router = new Router({
  base: "/",
  mode: "hash",
  linkActiveClass: "active",
  routes: paths,
  meta:{
    public:false,
    nomenu:false
  }
});

router.beforeEach((to, from, next) => {
  //debugger;
/*
  console.log(from);
  console.log(to);
  debugger;
*/
  if (!to.meta.public) {
    if (to.path === '/searchLogByPhone'){
      //console.log(to);
      localStorage.setItem("redirect", JSON.stringify(to));
      next("/searchLogByPhone");
      return;
    }
    if (!store.state.auth.loggedIn) {
      //console.log(to);
      localStorage.setItem("redirect", JSON.stringify(to));
      next("/login");
      return;
    }
  }

  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  //console.log("store:", store);
  
  //if (document.readyState == "completed") {
    //NProgress.done();
  //}
})

export default router;
